const dbColsOptions = [
	{ label: 'Intern', value: 'id' },
	{ label: 'RFID', value: 'rfid' },
	{ label: 'SmartCardNo', value: 'smartCardNumber' },
	{ label: 'FilterCode', value: 'filterCode' },
	{ label: 'UID', value: 'uuid' },
	{ label: 'Bezeichnung', value: 'name' },
	{ label: 'Valid', value: 'isActive' },
	{ label: 'Ablauf', value: 'expiry' },
	{ label: 'Saldo', value: 'balance' },
	{ label: 'Limit', value: 'limit' },
	{ label: 'Typ', value: 'type' },
	{ label: 'Anrede', value: 'salutation' },
	{ label: 'Name', value: 'clientName' },
	{ label: 'Vorname', value: 'clientSurname' },
	{ label: 'Zusatz', value: 'additive' },
	{ label: 'Strasse', value: 'street' },
	{ label: 'PLZ', value: 'postcode' },
	{ label: 'Ort', value: 'city' },
	{ label: 'TelefonP', value: 'phoneNumber' },
	{ label: 'Email', value: 'email' },
	{ label: 'IsBenutzer', value: 'isUser' },
	{ label: 'DayLimit', value: 'dayLimit' },
	{ label: 'SaldoRabatt', value: 'balanceDiscount' },
	{ label: 'CashLoad', value: 'cashLoad' },
	{ label: 'Points1', value: 'points' },
	{ label: 'Points1Active', value: 'isPointsActive' },
	{ label: 'AlwaysDiscount', value: 'alwaysDiscount' },
	{ label: 'EANCode', value: 'barCode' },
	{ label: 'Country', value: 'country' },
	{ label: 'Points1Active', value: 'isPointsActive' },
	{ label: 'Company', value: 'company' },
	{ label: 'CompanyAdditional', value: 'companyAdditional' },
	{ label: 'Birthday', value: 'birthday' },
	{ label: 'BalancePoints', value: 'balancePoints' }
]

export default dbColsOptions
